import axiosBackEnd from "../../config/axios/axios-back-end";
import { apiStart, apiFail, apiComplete } from "./api";
import { message } from "antd";

export const indexformatGetFormats = () => {
  return async (dispatch) => {
    dispatch(apiStart);
    try {
      const result = await axiosBackEnd.get("/api/indexformat", null, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(apiComplete());
      console.log(result.data, "result data set");
      return result.data.formats;
    } catch (error) {
      console.log(error);
      message.error(error.message);
      dispatch(apiComplete());
      // message.error('Unable to retrieve date formats')
      return [];
    }
  };
};
